import { useCommercialAgreementOffers } from '@hooks/queries/commercialAgreements/useCommercialAgreementOffers';
import { useParties } from '../../contexts/PartiesContext';

export const useInboundCommercialAgreementRequests = () => {
  const { party } = useParties();
  const offers = useCommercialAgreementOffers();
  const filtered = offers.data?.filter((o) => o.payload.user === party);
  return filtered || [];
};
